import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { PuffLoader } from "react-spinners";
import { useRequest } from "ahooks";
import downloadjs from "downloadjs";
import html2canvas from "html2canvas";
import moment from "moment";
import { FaCheck } from "react-icons/fa";
import "./Static.scss";
import { MembershipCardImage } from "../../assets";
import { getImageUrl } from "../../utils/getUrl";
import MembershipDB from "../../hooks/model/membership";

function MembershipCardPage() {
  const { id } = useParams();
  // const printRef = useRef();
  const [membershipData, setMembershipData] = useState(null);
  // please change to create user
  const { loading, run } = useRequest(MembershipDB.getOne, {
    manual: true,
    onSuccess: (data) => {
      if (data?.status) {
        setMembershipData(data?.data);
      }
    },
  });

  useEffect(() => {
    if (id) {
      run({
        memberId: id,
      });
    }
  }, [id]);

  const handleCaptureClick = async () => {
    const printContent = document.querySelector(".print-membership-body");
    if (!printContent) return;

    const canvas = await html2canvas(printContent, {
      allowTaint: true,
      useCORS: true,
      scale: 15,
    });
    const dataUrl = canvas.toDataURL("image/png");

    downloadjs(
      dataUrl,
      `${membershipData?.st_name?.split(" ").join("-")}-Member-Card.png`,
      "image/png"
    );
  };

  useEffect(() => {
    if (membershipData) {
      handleCaptureClick();
    }
  }, [membershipData, handleCaptureClick]);

  if (loading)
    return (
      <div className='loading-container'>
        <PuffLoader color='#FFFFFF' />
      </div>
    );

  if (!membershipData)
    return (
      <div className='loading-container' style={{ color: "#FFFFFF" }}>
        <div style={{ textAlign: "center" }}>
          <h3>Something wrong!</h3>Please make sure you generate staff card.
        </div>
      </div>
    );

  return (
    <div className='ssc_membership_card_container'>
      <div className='print-membership-body'>
        <img
          src={MembershipCardImage}
          className='membership-card-image'
          alt='image23-card'
          draggable={false}
        />

        {membershipData?.expire_at <= moment().format("YYYY-MM-DD") && (
          <div className='box-status-opacity'>
            <div>EXPIRED</div>
            <div id='paid-date'>{moment(membershipData?.expire_date).format("DD/MMM/YYYY")}</div>
          </div>
        )}

        {membershipData?.image !== "instructor-profile/default.png" ? (
          <div className='card-profile-image'>
            <img
              className='worker_image'
              draggable={false}
              src={getImageUrl(membershipData?.profile_img)}
              alt=''
            />
          </div>
        ) : null}

        <div className='card-name'>{membershipData?.st_name}</div>
        <div className='card-birthdate'>
          {moment(membershipData?.birthdate).format("DD-MMM-YYYY")}
        </div>

        {/* gender section */}
        {membershipData?.st_gender === "Male" && (
          <div className='card-check-male'>
            <FaCheck />
          </div>
        )}
        {membershipData?.st_gender === "Female" && (
          <div className='card-check-female'>
            <FaCheck />
          </div>
        )}
        <div className='card-phone'>{membershipData?.contactnumber}</div>
        <div className='card-amount'>{membershipData?.amount}</div>
        <div className='card-date'>{moment(membershipData?.date).format("DD-MMM-YYYY")}</div>

        {/* membership details section */}
        {membershipData?.duration === "1 Month" && (
          <div className='card-duration-1month'>
            <FaCheck size={12} />
          </div>
        )}
        {membershipData?.duration === "6 Months" && (
          <div className='card-duration-6month'>
            <FaCheck size={12} />
          </div>
        )}
        {membershipData?.duration === "2 Years" && (
          <div className='card-duration-2year'>
            <FaCheck size={12} />
          </div>
        )}

        {membershipData?.duration === "3 Months" && (
          <div className='card-duration-3month'>
            <FaCheck size={12} />
          </div>
        )}
        {membershipData?.duration === "12 Months" && (
          <div className='card-duration-12month'>
            <FaCheck size={12} />
          </div>
        )}
        {membershipData?.duration === "3 Years" && (
          <div className='card-duration-3year'>
            <FaCheck size={12} />
          </div>
        )}

        <div className='card-startdate'>
          {moment(membershipData?.start_date).format("DD-MMM-YYYY")}
        </div>

        {/* payment section */}
        {membershipData?.payment_method === "cash" && (
          <div className='card-check-cash'>
            <FaCheck />
          </div>
        )}
        {membershipData?.payment_method === "bank" && (
          <div className='card-check-bank'>
            <FaCheck />
          </div>
        )}
      </div>
    </div>
  );
}

export default MembershipCardPage;
